const firebaseConfig = {
    apiKey: "AIzaSyAPv95HiVu76Yo0meoxkxWkG88VRh2uum4",
    authDomain: "entremax-tech.firebaseapp.com",
    projectId: "entremax-tech",
    storageBucket: "entremax-tech.firebasestorage.app",
    messagingSenderId: "563668342115",
    appId: "1:563668342115:web:6925e6cd18254701b3ef56",
    measurementId: "G-ZJXSP417YS"
};

export default firebaseConfig;